import { useState } from "react";
import { sendSignupOtp } from "../../services/otp.service.js";
import AppError from "../../utils/AppError.js";
import getMessage from "../../utils/getMessage.js";
import { useNavigate } from "react-router-dom";
import "../../styles/auth/auth.css";
import { passwordValidator } from "../../validators/auth.validators.js";
import PasswordInput from "../../components/auth/PasswordInput.jsx";
import AuthSubmitButton from "../../components/auth/AuthSubmitButton.jsx";
import EmailInput from "../../components/auth/EmailInput.jsx";
import NameInput from "../../components/auth/NameInput.jsx";
import ErrorText from "../../components/auth/ErrorText.jsx";
import GoToLogin from "../../components/auth/GoToLogin.jsx";

const Signup = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setLoading(true);

    try {
      passwordValidator(password);
      await sendSignupOtp({ email });
      navigate("/verify-otp", {
        state: {
          email,
          password,
          firstName,
          lastName,
        },
      });
    } catch (error) {
      if (error instanceof AppError) {
        setError(error.message);
      } else {
        setError(getMessage("common", "error"));
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="outer">
      <h1 className="auth-heading">Welcome to VisualLab!</h1>
      <form onSubmit={handleSubmit} className="auth-form">
        <ErrorText error={error} />

        <NameInput
          firstName={firstName}
          setFirstName={setFirstName}
          lastName={lastName}
          setLastName={setLastName}
          loading={loading}
        />

        <EmailInput email={email} setEmail={setEmail} loading={loading} />

        <PasswordInput
          password={password}
          setPassword={setPassword}
          loading={loading}
        />

        <AuthSubmitButton
          loading={loading}
          text="GET OTP"
          disabledText="Sending OTP..."
        />
        <GoToLogin loading={loading} />
      </form>
    </div>
  );
};

export default Signup;
